import { useFormikContext } from "formik";
import { Paper, Stack, Typography, useTheme } from "@mui/material";
import { HugeiconsIcon } from "@hugeicons/react";
import { Search01Icon } from "@hugeicons/core-free-icons";
import Alias from "@/components/Alias";

const SeoMetadataSection = () => {
  const { values, setFieldValue } = useFormikContext<any>();
  const theme = useTheme();

  const handleAliasChange = (value: string) => {
    setFieldValue("organization.alias", value);
  };

  return (
    <Paper sx={{ p: 3, borderRadius: 3, mb: 3 }}>
      <Stack spacing={3}>
        {/* Section Title with Icon */}
        <Stack direction="row" spacing={2} alignItems="center">
          <HugeiconsIcon icon={Search01Icon} size={32} color={theme.palette.primary.main} />
          <Typography variant="h3">URL</Typography>
        </Stack>

        <Stack spacing={2.5}>
          {/* URL de tu sitio */}
          <Box sx={{ display: "flex", width: "100%" }}>
            <Alias
              isVerified
              value={values.organization?.alias ?? ""}
              onChange={handleAliasChange}
              sx={{
                width: "100%",
                "& .field-container": {
                  border: "2px solid #00000015",
                  borderTopLeftRadius: 8,
                  borderBottomLeftRadius: 8,
                  borderRight: "none",
                  bgcolor: "rgba(0, 0, 0, 0.02)",
                  display: "flex",
                  alignItems: "center",
                  px: 2,
                },
                "& .alias-input .MuiOutlinedInput-root": {
                  border: "2px solid #00000015",
                  borderTopLeftRadius: 0,
                  borderBottomLeftRadius: 0,
                  bgcolor: "white",
                },
              }}
            />
          </Box>
        </Stack>
      </Stack>
    </Paper>
  );
};

// Box helper to resolve TypeScript jsx compilation error for local element
const Box = ({ children, sx }: { children: React.ReactNode; sx?: any }) => {
  return <div style={{ display: "flex", width: "100%", ...sx }}>{children}</div>;
};

export default SeoMetadataSection;
